import api from './api';

// The CRM side of the Figma localization flow: the banners the plugin has pushed, what is in each
// of them, and the verdicts that publish their translations. Brand travels on the X-Brand header
// like every other dashboard call.
export const figmaReviewAPI = {
  listBanners: () => api.get('/api/figma-localization-review/banners'),
  getBanner: (id) => api.get(`/api/figma-localization-review/banners/${id}`),
  approve: (approvals) => api.post('/api/figma-localization-review/approve', { approvals }),
};

export default figmaReviewAPI;
